// removed by extract-text-webpack-plugin
module.exports = {"op":"_3rYOEU3HN0JNCWl1Zh-Qic","img1":"teJNfEvzMrvZTVK0plvTh","additional":"_36pwpbyUAxTmdZXh208uA7"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MiddleNav/MiddleNav.scss
 ** module id = 994
 ** module chunks = 0
 **/